export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/rep/lesson/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryWithResourseNum(data) {
            return http.json({
                url: `/rep/lesson/queryWithResourseNum?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/rep/lesson/get?id=${data.id}`,
                data
            })
        },
        queryAll(data) {
            return http.json({
                url: `/rep/lesson/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/rep/lesson/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/rep/lesson/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/rep/lesson/delete`,
                data
            })
        },
        deleteComment(data) {
            return http.json({
                url: `/rep/lesson/deleteComment`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/rep/lesson/updateState`,
                data
            })
        },
        updateSuggested(data) {
            return http.json({
                url: `/rep/lesson/updateSuggested`,
                data
            })
        },
        queryLessonComment(data) {
            return http.json({
                url: `/rep/lesson/queryLessonComment?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/lesson.js